module.exports = __webpack_public_path__ + "img/cnn.ebbfb02c.jpg";